module.exports = "/virtual-football-league/img/amblems/left/Italy/Fake_Inter.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/Italy/Fake_Inter.png
// module id = 2039
// module chunks = 4